@if (loading) {
<div>
  <div class="flex-container-center margin-bottom-15">
    <mat-spinner></mat-spinner>
  </div>
  <div class="flex-container-center">
    {{ 'orders.saving' | transloco }}
  </div>
</div>
}

@if (!loading && orders.length > 0) {
<lib-validation-problems [validation]="notices" [useStaticValidation]="true"></lib-validation-problems>
<div>
  <!-- Orders table -->
  <table mat-table [dataSource]="orders" multiTemplateDataRows>
    <ng-container matColumnDef="criteria">
      <th mat-header-cell *matHeaderCellDef id="criteria"> {{ 'orders.searchCriteria' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order"
        [style.cursor]="hasErrors(order) || hasWarnings(order) ? 'pointer' : 'default'"> {{
        getOrderCriteria(order.resource) }} </td>
    </ng-container>
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef id="country">{{ 'common.labels.country' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order"
        [style.cursor]="hasErrors(order) || hasWarnings(order) ? 'pointer' : 'default'">
        {{ order.resource.country }}
      </td>
    </ng-container>
    <ng-container matColumnDef="jurisdiction">
      <th mat-header-cell *matHeaderCellDef id="jurisdiction">
        {{ 'common.labels.jurisdiction' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order"
        [style.cursor]="hasErrors(order) || hasWarnings(order) ? 'pointer' : 'default'">
        {{ order.resource.jurisdiction | jurisdictionLabel:order.resource.country:order.resource.displayJurisdiction }}
      <td>
    </ng-container>
    <ng-container matColumnDef="validation">
      <th mat-header-cell *matHeaderCellDef id="validation">
        {{ 'common.labels.validation' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order"
        [style.cursor]="hasErrors(order) || hasWarnings(order) ? 'pointer' : 'default'">
        @if (hasErrors(order)) {
        <mat-icon class="margin-left-5 icon-error">error</mat-icon>
        }
        @if (hasWarnings(order)) {
        <mat-icon class="margin-left-5 icon-warning">warning</mat-icon>
        }
        @if (!hasErrors(order) && !hasWarnings(order)) {
        <mat-icon class="margin-left-5 icon-success">check_circle</mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let order" [attr.colspan]="displayedColumns.length">
        <div class="expanded-entity-detail" [@detailExpand]="order === _expandedOrder ? 'expanded' : 'collapsed'">
          <div class="expanded-entity-information">
            <lib-validation-problems [useStaticValidation]="true" [validation]="order.validation"
              [order]="order.resource" [neverShowNotices]="true"></lib-validation-problems>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let order; columns: displayedColumns;" class="expandable-table-row"
      [class.example-expanded-row]="_expandedOrder === order" (click)="onRowClick(order)" tabindex="0" (keydown.enter)="onRowClick(order)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'] " class="expandable-detail-row">
    </tr>
  </table>
  <!-- End of orders table-->
</div>
}

<lib-placeholder iconName="error" iconClass="icon-error" [message]="'orders.noJurisdictionsSelected' | transloco"
  [condition]="!loading && orders.length === 0"></lib-placeholder>